import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Header from '../../header';
import Footer from '../../footer';
import styles from '@/styles/Template.module.css';
import ServiceManagementAutomatic from '@/pages/images/serviceManagementAutomatic';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from "swiper";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import RightArrow from '@/pages/images/rightArrow';
import StepFirst from '@/pages/images/stepFirst';
import StepSecond from '@/pages/images/stepSecond';
import StepThird from '@/pages/images/stepThird';
import Image, { ImageLoaderProps } from 'next/image';
import { IMAGE_DELIVERY, imageLoader } from "@/base/utils/dataHelper";
import PageSeo from '@/components/seo/PageSeo';

const AccountPayableOperations = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();

  type PreviewTab = 'form' | 'workflow';
  const [activePreviewTab, setActivePreviewTab] = useState<PreviewTab>('form');

  return (
    <>
      <PageSeo title={`${t("accountsPayableOperations")} | Stoneity`} description={t("accountsReceivableDefinition")} locale={router.locale} />
      <Header />
      <div className={styles.mainFlex}>
        <div className={styles.templateBannerBackground}>
          <div className={styles.templateBannerWrapper}>
            <div className={styles.templateBannerLeft}>
              <div className={styles.templateBannerTitle}>{t("manageReceivables")}</div>
              <div className={styles.templateBannerDescription}>{t("trackInvoicesAndCollections")}</div>
            </div>
            <div className={styles.circleContent}>
              <div className={styles.circleBackground}></div>
              <div className={styles.circleRing}><span className={styles.ring}></span></div>
              <div className={styles.circleUserWrapper}>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-6.png" alt="" />
                  </div>
                  {t("projectManagementText")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-4.png" alt="" />
                  </div>
                  {t("taskManagement")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-2.png" alt="" />
                  </div>
                  {t("operations")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-5.png" alt="" />
                  </div>
                  {t("portfolio")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-3.png" alt="" />
                  </div>
                  {t("salesAndCRM")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-1.png" alt="" />
                  </div>
                  {t("marketing")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pageFlex}>
          <div className={styles.templateInfoWrapper}>
            <div className={styles.textWrapperFlex}>
              <div className={styles.textWrapper}>
                <div className={styles.title}>{t("accountsPayableOperations")}</div>
                <div className={styles.description}>{t("accountsReceivableDefinition")}</div>
              </div>
            </div>
            <div className={styles.templateInfoBottom}>
              <div className={styles.templateInfoLeft}>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'form' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('form')}>
                  <div className={styles.templateInfoTitle}>
                    {t("form")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    sdafkjasldkfjaklş
                  </div> */}
                </div>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'workflow' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('workflow')}>
                  <div className={styles.templateInfoTitle}>
                    {t("workflowText")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    asdkfjşkladsjfasdlşk
                  </div> */}
                </div>
              </div>
              <div className={styles.templateInfoRight}>
                {activePreviewTab === 'form' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/fcd802f7-4499-4519-23b1-f15eaa37bc00` : `${IMAGE_DELIVERY}/ffa002c5-880c-4605-bedd-6f3873406d00`}
                    alt={""}
                    width={640}
                    height={815}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 640, 815)}
                  />
                )}
                {activePreviewTab === 'workflow' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/74375371-a159-41da-b5ab-140c8e254c00` : `${IMAGE_DELIVERY}/3fe7b6f2-55f0-4555-7404-81f8b16e5900`}
                    alt={""}
                    width={460}
                    height={450}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 460, 450)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.pageFlex}>
          <div className={styles.howToWrapper}>
            <div className={styles.textWrapper}>
              <div className={styles.title}>{t("howToImplementSolutions")}</div>
            </div>
            <div className={styles.howToCardWrapper}>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepFirst />
                  <div className={styles.howToCardTitle}>{t("establishLocationAssetModel")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("defineBuildingInventory")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepSecond />
                  <div className={styles.howToCardTitle}>{t("defineSlotPlanningStandard")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("connectTimeSlotsToWorkflow")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepThird />
                  <div className={styles.howToCardTitle}>{t("measurePerformance")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("trackWorkplaceMetrics")}</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default AccountPayableOperations;
